// The SENTINEL wordmark set inside its own tolerance band (D-072) — the type
// half of the brand lockup; callers place BrandMarkIcon beside it as before.
// `inverse` is for the always-dark login/recover aside panels.
import * as stylex from '@stylexjs/stylex';
import '../../tokens/colors.stylex';
import { colors } from '../../tokens/colors.stylex';
import '../../tokens/typography.stylex';
import { typography } from '../../tokens/typography.stylex';
interface WordmarkProps {
  size?: 'md' | 'lg';
  /** Small caps line under the band, e.g. "by Xantory". */
  sub?: string;
  /** Force light ink on the always-dark brand panels. */
  inverse?: boolean;
}
export function Wordmark({
  size = 'md',
  sub,
  inverse = false
}: WordmarkProps) {
  return <span className="x3nfvp2 xdt5ytf x1ed6fcf">
      <span className="xuquc1b xqu132l xwq05k6" />
      <span {...{
      0: {
        className: "xhosb2f x1u1phio xomqrzn x14k033y x1qv67nb x1159mfc x1oezkus xsplgde xuxw1ft"
      },
      2: {
        className: "xhosb2f x1u1phio xomqrzn x1qv67nb x1159mfc x1oezkus xsplgde xuxw1ft x19b9xl8"
      },
      1: {
        className: "xhosb2f x1u1phio xomqrzn x14k033y x1qv67nb x1159mfc xsplgde xuxw1ft xbijz3y"
      },
      3: {
        className: "xhosb2f x1u1phio xomqrzn x1qv67nb x1159mfc xsplgde xuxw1ft x19b9xl8 xbijz3y"
      }
    }[!!(size === 'lg') << 1 | !!inverse << 0]}>
        SENTI<span className="x1459q0w">NEL</span>
      </span>
      <span className="xuquc1b xqu132l xwq05k6 xpk2tj9" />
      {sub && <span className="x1gs96k x1sfnd48 xribhvm xtvhhri xdxw5r1 x7r5mf7">{sub}</span>}
    </span>;
}